import { render, staticRenderFns } from "./JettonTabHistoryRow.vue?vue&type=template&id=6ffeec95"
import script from "./JettonTabHistoryRow.vue?vue&type=script&lang=js"
export * from "./JettonTabHistoryRow.vue?vue&type=script&lang=js"
import style0 from "./JettonTabHistoryRow.vue?vue&type=style&index=0&id=6ffeec95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports